export default __webpack_public_path__ + "static/media/sc-pin-ico.169a5e4d.svg";